const passwordPatterns = [
  {
    limit: 8,
    message: 'password_should_contain_characters'
  },
  {
    pattern: /[A-Z]/g,
    message:'password_should_contain_capital_letter'
  },
  {
    pattern: /[0-9]/g,
    message: 'password_should_contain_number'
  },
  {
    pattern: /[a-z]/g,
    message: 'password_should_contain_small_letter'
  },
  {
    pattern: /[!@#$%^&]/g,
    message: 'password_should_contain_special_characters'
  }
];
const namePatterns = (value) => {
  const emoji = {
    pattern: /\p{Extended_Pictographic}/u,
    message: 'invalid_character'
  };
  if (emoji.pattern.test(value)) return emoji.message;
};
const validatePatterns = (value) => {
  const [miLength, ...rest] = passwordPatterns;
  for (const obj of rest) {
    if (obj?.pattern && !value.match(obj?.pattern)) return obj.message;
  }
  if (value.length < miLength.limit) return miLength.message;
};
// All signup form validation options should be used from this place
const signupOptions = {
  firstName: {
    required: 'first_name_is_required',
    maxLength: {
      value: 20,
      message: 'first_name_character_limit'
    },
    validate: {
      namePatterns: (value) => namePatterns(value)
    }
  },
  lastName: {
    required: 'last_name_is_required',
    maxLength: {
      value: 20,
      message: 'last_name_character_limit'
    },
    validate: {
      namePatterns: (value) => namePatterns(value)
    }
  },
  email: {
    required: 'email_is_required',
    pattern: {
      value: RegExp('^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+[.]+[.a-zA-Z]{2,8}$'),
      message: 'invalid_email_address'
    },
    maxLength: {
      value: 100,
      message: 'email_max_character_length'
    }
  },
  password: {
    required: 'password_is_required',
    validate: {
      passwordPatterns: (value) => validatePatterns(value)
    },
    maxLength: {
      value: 32,
      message: 'password_character_limit'
    }
  },
  captcha: {
    required: 'please_verify_whether_you_are_a_human'
  },
  acceptTerms: {
    required: 'please_check_these_terms'
  },
  acceptTermsManual: {
    type: 'manual',
    message: 'please_check_these_terms'
  },
  emailManual: {
    type: 'manual',
    message: 'email_is_already_registered'
  }
};

const defaultValues = {
  firstName: '',
  lastName: '',
  password: '',
  email: '',
  captcha: '',
  acceptTerms: false
};
export { signupOptions, defaultValues };
